'use client'

import { Button } from '@/components/ui/button'

interface ErrorActionsProps {
  onRetry: () => void
  onBack: () => void
  retryLabel?: string
  backLabel?: string
}

export function ErrorActions({
  onRetry,
  onBack,
  retryLabel = 'Retry',
  backLabel = 'Go back',
}: ErrorActionsProps) {
  return (
    <div className="flex gap-2">
      <Button onClick={onRetry}>{retryLabel}</Button>
      <Button variant="outline" onClick={onBack}>
        {backLabel}
      </Button>
    </div>
  )
}
